export default __webpack_public_path__ + "resources/icons/d320-10a6.webp";